
import { Box, Card, CardActions, CardContent, CardMedia, Grid, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { memo, useContext, useEffect, useState } from 'react'
// import { AuthenticationContext } from '../../context/AuthenticationContext'
import { WmcContext } from '../../context/WmcContext'
import { WEB_KEY } from '../../api/AxiosApi'
import Image from 'mui-image'
import { BusinessAuthenticationContext } from '../../context/BussinessAuthenticationContext'
import { BusinessHeaderApi } from '../../api/Api'
import { AppThemeContext } from '../../context/AppThemeContext'
import { BaseUrl } from '../../api/AxiosApi'

function TopHeaderBusiness() {
     const { PrimaryColor } = useContext(AppThemeContext);
    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { LoggedInUserInfoIn } = useContext(BusinessAuthenticationContext)
    // const { BrandLogo } = useContext(WmcContext)
    const { breakpoints, spacing } = useTheme()
    const LOGIN_ID = localStorage.getItem('LOGIN_ID')
    //const LOC_CODE = localStorage.getItem('LCODE')
    const matches = useMediaQuery(breakpoints.down('xl'));
    // console.log('DATAUSER', LoggedInUserInfo)
    const LOC_CODE = LoggedInUserInfoIn?.Loc_Code
    const PASS_KEY = "xxxxxx"
    // const ImageUrl = "https://log.solaramr.com/api/CMN_02/GET_COM_LOGO?LOGIN_ID=2402104&LOC_CODE=200ET&PASS_KEY=xxxxxx&WEB_KEY=WEBXYZ321"
    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`
    // console.log('LOGO', LOC_CODE)

    // console.log("login_id",LOGIN_ID)




    const credentials = {
        SUSER: LOGIN_ID,
        SS_KEY: localStorage.getItem("SS_KEY") || "",
        USER_NAME: "LOGICS",
        USER_TYPE: "SOLAR"
    };

    console.log("credentials", credentials)

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);
        try {
            const res = await BusinessHeaderApi(credentials);
            console.log("API Response:", res); // Check what API returns
            if (res && typeof res === "object") {
                setLogData([res]); // Convert object to array
            } else {
                setLogData([]);
            }
            
        } catch (err) {
            console.error("Error fetching data:", err);
            setError("Failed to fetch data. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    

    useEffect(() => {
        fetchLogData(); // Fetch data initially

        const interval = setInterval(() => {
            fetchLogData(); // Fetch data every 40 seconds
        }, 30000); // 40 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, [credentials.LOGIN_ID]); // Dependency ensures it updates when LOGIN_ID changes


    // console.log("logDataheader", logData)

    return (
        <Stack rowGap={spacing(1)}>
            <Card elevation={0} sx={{ bgcolor: 'lightgrey' }}>
                <CardActions>
                    <marquee>
                        <Typography variant='body1' color={'black'}>
                            Industrial Energy Management System Flow Meter & Ground Water Monitoring Smart Metering and DLMS Solution Industrial Energy Management System Flow Meter & Ground Water Monitoring
                        </Typography>
                    </marquee>
                </CardActions>
            </Card>
            <Grid container spacing={spacing(1)}>


                {/* <Grid item xs={12} sm={12} md={4}>
                    <Card sx={{ height: matches ? 50 : 70, p: spacing(1), display: 'flex', alignItems: "center" }}>
                        <Stack>
                            <Typography textAlign={'start'} variant='body1'>{LoggedInUserInfoIn?.username}&nbsp; &nbsp;<span>(User_Id:{LOGIN_ID})</span></Typography>
                           
                        </Stack>
                    </Card>
                </Grid> */}

                {logData.map((item, index) => (
                    <>
                    
                  
                    <Grid item xs={12} sm={12} md={4} key={index}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <Card sx={{ height: matches ? 50 : 70, p: 1, display: 'flex', alignItems: 'center' }}>
                                    <Stack>
                                        <Typography textAlign={'start'} variant='body1'>User Id: &nbsp;<span style={{color: PrimaryColor,fontWeight:"800"}}>{LOGIN_ID}</span></Typography>
                                        <Typography textAlign={'start'} variant='body1'>User Name: &nbsp;<span style={{color: PrimaryColor,fontWeight:"800"}}>{ LoggedInUserInfoIn?.USER_NAME}</span></Typography>
                                    </Stack>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card sx={{ height: matches ? 50 : 70, p: 1, display: 'flex', alignItems: 'center' }}>
                                    <Stack>
                                    <Typography textAlign={'start'} variant='body1'>Total Inverters:&nbsp;&nbsp;<span style={{color: PrimaryColor,fontWeight:"800",fontsize:"12px"}}>{item?.CN ?? 'N/A'}</span></Typography>
                                    <Typography textAlign={'start'} variant='body1'>Live Inverters:&nbsp;&nbsp;<span style={{color: PrimaryColor,fontWeight:"800",fontsize:"12px"}}>{item?.live ?? 'N/A'}</span></Typography>
                                    <Typography textAlign={'start'} variant='body1'>Offline Inverters:&nbsp;&nbsp;<span style={{color: PrimaryColor,fontWeight:"800",fontsize:"12px"}}>{item?.offline ?? 'N/A'}</span></Typography>
                                    </Stack>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>




                <Grid item xs={12} sm={12} md={4}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Card sx={{ height: matches ? 50 : 70, p: 1, display: 'flex', alignItems: 'center' }}>
                                <Stack>
                                <Typography textAlign={'start'} variant='body1'>Total User/Plant: &nbsp;&nbsp;<span style={{color: PrimaryColor,fontWeight:"800",fontsize:"12px"}}>{item?.Total_user ?? 'N/A'}</span></Typography>
                                <Typography variant="body1">Total Capacity : &nbsp;&nbsp;<span style={{color: PrimaryColor,fontWeight:"800",fontsize:"12px"}}>{item?.TOT_KWP ?? 'N/A'}</span></Typography>
                               <Typography textAlign={'start'} variant='body1'>Total Group:&nbsp;&nbsp;<span style={{color: PrimaryColor,fontWeight:"800",fontsize:"12px"}}>{item?.Total_Group ?? 'N/A'}</span></Typography>
                                
                                </Stack>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Card sx={{ height: matches ? 50 : 70, p: 1, display: 'flex', alignItems: 'center' }}>
                                <Stack>
                                <Typography variant="body1">Total Yield : &nbsp;&nbsp;<span style={{color: PrimaryColor,fontWeight:"800",fontsize:"12px"}}>{item?.TOT_KWH ?? 'N/A'}</span></Typography>
                                <Typography textAlign={'start'} variant='body1'>Revenue Gains(₹):&nbsp;&nbsp;<span style={{color: PrimaryColor,fontWeight:"800",fontsize:"12px"}}>{item?.TOT_Rev ?? 'N/A'}</span></Typography>
                                <Typography variant="body1">CO2 Reduction:&nbsp;&nbsp;<span style={{color: PrimaryColor,fontWeight:"800",fontsize:"12px"}}>{item?.co2_ton ?? 'N/A'}</span></Typography>
                                </Stack>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
                </>
                ))}


                <Grid item xs={12} sm={12} md={4} display={'flex'} justifyContent={'center'}>
                    <Image fit='fill'
                        wrapperStyle={{
                            height: matches ? 50 : 70, borderRadius: "11px",
                            overflow: "hidden"
                        }}
                        src={ImageUrl ? ImageUrl : require('../../assets/img/basic/battery.png')}
                    />
                </Grid>
            </Grid>
        </Stack >
    )
}

export default memo(TopHeaderBusiness)